module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/miso-soup-5aaf1a6ce2b8e92a0aa1126447ae4f09.svg";